<template>
    <div>
                        <a :href="SendBest">
                        <img class="img img-raised" :src="SendBestImg" alt="">
                        </a>
                        <br><br>
                        <a :href="RightOneLink" target="_blank">
                        <img class="img img-raised" :src="RightOne" alt="">
                        </a>
                        <br><br>
                        <a :href="RightTwoLink" target="_blank">
                        <img class="img img-raised" :src="RightTwo" alt="">
                        </a>
                        <br><br>
                        <!-- Best Australia Betting sites End -->
                        <card>
                            <h6 class="category text-center text-danger">
                             BEST AUSTRALLIA SPORTS BETTING WEBSITES
                            </h6>
                                    <el-table class="card-body"
                                                :data="bestAustraliaBettingSites" >
                                            <el-table-column min-width="45" align="left">
                                                <div slot-scope="{row}" class="img-container">
                                                    <img :src="row.logo" alt="Picture" width="45">
                                                </div>
                                            </el-table-column>
                                            <el-table-column min-width="100" max-width='100'>
                                              <div class="td-name mar-10" slot-scope="{row}">
                                                <a :href="row.siteLink" target="_blank">{{row.name}}</a>
                                                
                                              </div>
                                            </el-table-column>
                                            <el-table-column min-width="100"  align="right">
                                                <div class="td-number" slot-scope="{row}">
                                                <div class="btn-group">
                                                    <!-- <n-button type="primary" size="sm" @click.native="decreaseQuantity(row)">
                                                     Review
                                                    </n-button> -->
                                                    <a class="btn btn-primary btn-sm" size="sm" v-bind:href="row.reviewLink">
                                                      Review
                                                    </a>
                                                </div>
                                                </div>
                                            </el-table-column>
                                        </el-table>

                        </card>  
                        <!-- Best Australia Betting sites End -->  
                        <!-- Best USA Betting sites -->
                        <card>
                            <h6 class="category text-center text-danger">
                             BEST USA SPORTS BETTING WEBSITES
                            </h6>
                                    <el-table class="card-body"
                                                :data="bestUsBettingSites" >
                                            <el-table-column min-width="45" align="left">
                                                <div slot-scope="{row}" class="img-container">
                                                    <img :src="row.logo" alt="Picture" width="45">
                                                </div>
                                            </el-table-column>
                                            <el-table-column min-width="100" max-width='100'>
                                              <div class="td-name mar-10" slot-scope="{row}">
                                                <a :href="row.siteLink" target="_blank">{{row.name}}</a>
                                                
                                              </div>
                                            </el-table-column>
                                            <el-table-column min-width="100" align="right">
                                                <div class="td-number" slot-scope="{row}">
                                                <div class="btn-group">
                                                    <a class="btn btn-primary btn-sm" size="sm" v-bind:href="row.reviewLink">
                                                      Review
                                                    </a>
                                                </div>
                                                </div>
                                            </el-table-column>
                                        </el-table>
                        </card>   
                        <a :href="FreeTip">
                        <img class="img img-raised" :src="FreeTipImg" alt="">
                        </a>
                        <br><br>
                        <!-- Best USA Betting sites End-->
                        <card type="blog">
                          <h3>Podcast</h3>
                          <p>Listen to our podcast on best betting tips</p>
                        </card>
    </div>
</template>
<script>
  import { Card, Button, FormGroupInput } from '@/components';
  import { Carousel, CarouselItem, Table, TableColumn } from 'element-ui'
  import db from '../../components/Firebase/firebaseInit'

  export default {
    name: 'side-bar',
    bodyClass: 'side-bar',
    components: {
      Card,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput
    },
    data() {
      return {
        SendBest: null,
        SendBestImg: null,
        RightOne: null,
        RightTwo: null,
        bestUsBettingSites: [],
        bestAustraliaBettingSites: [],
      }
    },
    created(){
    db.collection('bestUsBettingSites').get()
    .then(querySnapshot => {
      querySnapshot.forEach(doc => {
        const data = {
          'id': doc.id,
          'name': doc.data().name,
          'logo': doc.data().logo,
          'reviewLink': doc.data().reviewLink,
          'siteLink': doc.data().siteLink
        }
        this.bestUsBettingSites.push(data)
      })
    })
    db.collection('bestAustraliaBettingSites').get()
    .then(querySnapshot => {
      querySnapshot.forEach(doc => {
        const data = {
          'id': doc.id,
          'name': doc.data().name,
          'logo': doc.data().logo,
          'reviewLink': doc.data().reviewLink,
          'siteLink': doc.data().siteLink
        }
        this.bestAustraliaBettingSites.push(data)
      })
    })
    db.collection('homepageBanners').get()
    .then(querySnapshot => {
      querySnapshot.forEach(doc => {
        if(doc.data().name == 'RightOne'){
            this.RightOne = doc.data().link;
            this.RightOneLink = doc.data().imgLink;
        }else if(doc.data().name == 'RightTwo'){
            this.RightTwo = doc.data().link;
            this.RightTwoLink = doc.data().imgLink;
        }else if(doc.data().name == 'SendBest'){
            this.SendBest = "mailto:" + doc.data().imgLink;
            this.SendBestImg = doc.data().link;
         }else if(doc.data().name == 'FreeTip'){
            this.FreeTip = doc.data().imgLink;
            this.FreeTipImg = doc.data().link;
        }
      })
    })

    }
  }
</script>
<style>
.el-table__body-wrapper {
    overflow: visible !important;
    position: relative;
}
.table > thead > tr > th, .el-table table > thead > tr > th, .table > tbody > tr > th, .el-table table > tbody > tr > th, .table > tfoot > tr > th, .el-table table > tfoot > tr > th, .table > thead > tr > td, .el-table table > thead > tr > td, .table > tbody > tr > td, .el-table table > tbody > tr > td, .table > tfoot > tr > td, .el-table table > tfoot > tr > td {
    padding: 12px 0px !important;
    vertical-align: middle;
}
</style>
